import {
    SHOOTING_RESULTS_FAILURE,
    SHOOTING_RESULTS_REQUEST,
    SHOOTING_RESULTS_SUCCESS,
    SHOOTING_RESULT_SAVE_SUCCESS,
    SHOOTING_RESULT_REMOVE_SUCCESS,
} from 'actions';

const initialState = {
    // competitionId → CompetitionShootingResult[]
    dataByCompetition: {},
    isFetched: [],
    isFetching: [],
};

export const shootingResultListReducer = (state = initialState, action) => {
    const { type, data, result, competitionId } = action;
    switch (type) {
        case SHOOTING_RESULTS_SUCCESS:
            return {
                ...state,
                isFetched: [...state.isFetched.filter(id => id !== competitionId), competitionId],
                isFetching: state.isFetching.filter(id => id !== competitionId),
                dataByCompetition: {
                    ...state.dataByCompetition,
                    [competitionId]: data,
                },
            };

        case SHOOTING_RESULT_SAVE_SUCCESS: {
            const existing = state.dataByCompetition[competitionId] || [];
            const replaced = existing.some(r => r.id === result.id);
            return {
                ...state,
                dataByCompetition: {
                    ...state.dataByCompetition,
                    [competitionId]: replaced
                        ? existing.map(r => (r.id === result.id ? result : r))
                        : [...existing, result],
                },
            };
        }

        case SHOOTING_RESULT_REMOVE_SUCCESS:
            return {
                ...state,
                dataByCompetition: {
                    ...state.dataByCompetition,
                    [competitionId]: (state.dataByCompetition[competitionId] || []).filter(r => r.id !== action.id),
                },
            };

        case SHOOTING_RESULTS_REQUEST:
            return {
                ...state,
                isFetching: [...state.isFetching, competitionId],
            };

        case SHOOTING_RESULTS_FAILURE:
            return {
                ...state,
                isFetching: state.isFetching.filter(id => id !== competitionId),
            };

        default:
            return state;
    }
};
